
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import type { MortgageData } from "../CalculatorTabs";
import { calculateMortgageData } from '@/utils/calculator/mortgageCalculator';
import type { AutoCalculateOptions } from "../utils/types";

interface ConventionalLoanFieldsProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const ConventionalLoanFields: React.FC<ConventionalLoanFieldsProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate 
}) => {
  return (
    <div className="space-y-4 border-t border-border pt-4 mt-4">
      <h3 className="font-medium text-sm">Conventional Loan Details</h3>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="first-time-homebuyer-conventional"
          checked={mortgageData.isFirstTimeHomebuyer}
          onCheckedChange={(checked) => {
            setMortgageData(prev => {
              const updatedData = {
                ...prev,
                isFirstTimeHomebuyer: checked as boolean
              };
              return calculateMortgageData(updatedData);
            });
          }} 
        />
        <Label 
          htmlFor="first-time-homebuyer-conventional" 
          className="text-sm font-medium cursor-pointer"
        >
          First-Time Homebuyer
        </Label>
      </div>
      
      {/* Conventional Loan Information */}
      {mortgageData.isFirstTimeHomebuyer && (
        <div className="bg-muted/50 dark:bg-muted/10 rounded-md p-3 text-sm border border-border">
          <p className="font-medium text-green-600 dark:text-green-400">
            First-time homebuyers may qualify for special programs with lower down payment requirements and reduced rates.
          </p>
        </div>
      )}
    </div>
  );
};

export { ConventionalLoanFields };
